<template>
  <nav class="nav-bar">
    <slot />
  </nav>
</template>

<script>
export default {
  name: 'NavBar'
}
</script>

<style lang="sass">
@import '~styles/imports'

.nav-bar
  background: var(--navBarColor)
  border-radius: $border-radius
  display: flex
  margin-bottom: rem-calc($grid-gutter-width * 2)

  +respond-max($md)
    justify-content: center

</style>



// WEBPACK FOOTER //
// src/components/ui/NavBar.vue